/**
 * Quote Form Component
 */

import { BaseForm } from './base-form';
import { createModal } from '../modal';
import { submitQuoteForm, loadQuoteForm } from '../../services/forms';

export class QuoteForm extends BaseForm {
  constructor(element, options = {}) {
    super(element, {
      resetOnSuccess: false,
      ...options
    });
    
    this.productId = this.$form.data('product-id') || options.productId || null;
  }

  /**
   * Get additional form data
   */
  getAdditionalData() {
    const data = {
      action: 'submit_quote_form'
    };
    
    if (this.productId) {
      data.product_id = this.productId;
    }
    
    return data;
  }

  /**
   * Submit the quote form
   */
  async submitForm(formData) {
    return await submitQuoteForm(formData);
  }

  /**
   * Handle successful submission
   */
  onSuccess(response) {
    const message = response.data?.message || 
      window.hs?.strings?.quoteSuccess || 
      'Bedankt voor je offerte aanvraag. We nemen snel contact met je op met een gepersonaliseerde offerte.';
    
    const sentText = window.hs?.strings?.requestSent || 'Aanvraag verzonden!';
    
    // Replace form with success message
    this.$form.html(`
      <div class="text-center py-8">
        <div class="text-green-500 mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h3 class="text-xl font-semibold mb-2">${sentText}</h3>
        <p class="text-gray-600">${message}</p>
      </div>
    `);
    
    // If in modal, close after 3 seconds
    if (this.options.modal) {
      setTimeout(() => {
        this.options.modal.close();
      }, 3000);
    }
  }
}

/**
 * Quote Form Manager
 * Handles quote request buttons and modal forms
 */
export class QuoteFormManager {
  constructor() {
    this.modal = null;
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    jQuery(document).on('click', '.js-quote-request-button', (e) => {
      e.preventDefault();
      this.handleQuoteButtonClick(e);
    });
  }

  async handleQuoteButtonClick(event) {
    const $button = jQuery(event.currentTarget);
    const productId = $button.data('product-id');
    
    if (!productId) {
      console.error('No product ID found on quote button');
      return;
    }

    // Create modal if not exists
    if (!this.modal) {
      this.modal = createModal();
    }

    // Open modal and show loader
    this.modal.open();
    this.modal.showLoader();

    try {
      // Load quote form
      const response = await loadQuoteForm(productId);
      
      if (response.success) {
        // Set modal content
        this.modal.setContent(response.data.html);
        
        // Initialize form in modal
        const $form = jQuery('.js-quote-form', this.modal.getElements().content);
        if ($form.length) {
          new QuoteForm($form[0], {
            productId: productId,
            modal: this.modal
          });
        }
      } else {
        this.showErrorInModal(response.data?.message);
      }
    } catch (error) {
      console.error('Error loading quote form:', error);
      this.showErrorInModal();
    }
  }

  showErrorInModal(message = null) {
    const errorMessage = message || 
      window.hs?.strings?.quoteLoadError || 
      'Er is iets misgegaan bij het laden van het formulier. Probeer het later opnieuw.';
    this.modal.setContent(`
      <div class="text-center py-8">
        <div class="text-red-500 mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <p class="text-gray-600">${errorMessage}</p>
      </div>
    `);
    
    // Close modal after 3 seconds
    setTimeout(() => {
      this.modal.close();
    }, 3000);
  }
}

/**
 * Initialize quote form functionality
 */
export const initQuoteForm = () => {
  return new QuoteFormManager();
};

/**
 * Create quote form instance
 * For standalone forms (not in modal)
 */
export const createQuoteForm = (element, options = {}) => {
  return new QuoteForm(element, options);
};